import React, { useEffect, useState } from 'react';
import axios from "axios";
import { useParams } from "react-router-dom";
import { useAuth } from '../../../../../context/AuthContext';
import { API_BASE_URL } from '../../../../../Helpers/apiConfig';

export const Odemetest = () => {
    const { packageId, price } = useParams();
    const { user } = useAuth();
    const [token, setToken] = useState(null);
    const [loading, setLoading] = useState(false);
    const [msg, setMsg] = useState("");
    const [phone, setPhone] = useState("");

    const getPaymentToken = async (userPhone) => {
        setLoading(true);
        setMsg("");
        try {
            const headerss = {
                "accept": "*/*",
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + user.token
            };

            const res = await axios.post(
                API_BASE_URL + "/Paytr/GetToken",
                {
                    packageId: packageId,
                    userPhone: userPhone,
                },
                { headers: headerss }
            );

            if (res.data && res.data.success && res.data.token) {
                setToken("https://www.paytr.com/odeme/guvenli/" + res.data.token);
            } else {
                setMsg(res.data?.message || "Ödeme sayfası oluşturulamadı.");
            }
        } catch (err) {
            setMsg(err.response?.data?.message || "Ödeme sayfası oluşturulurken beklenmedik bir hata oluştu.");
        }
        setLoading(false);
    };

    useEffect(() => {
        const script = document.createElement("script");
        script.src = "https://www.paytr.com/js/iframeResizer.min.js";
        script.async = true;
        document.body.appendChild(script);
    }, []);

    const handlePhoneSubmit = (e) => {
        e.preventDefault();
        getPaymentToken(phone);
    };

    return (
        <div className="container text-center my-4">
            <h4>Ödeme — {price} TL</h4>
            <hr />

            {!loading && !token && (
                <form onSubmit={handlePhoneSubmit} className="mx-auto" style={{ maxWidth: "400px" }}>
                    <p className="text-muted">Ödemeye devam etmek için telefon numaranızı girin.</p>
                    <div className="mb-3">
                        <input
                            type="tel"
                            className="form-control"
                            placeholder="05XX XXX XX XX"
                            value={phone}
                            onChange={(e) => setPhone(e.target.value)}
                            required
                        />
                    </div>
                    {msg && <div className="alert alert-danger">{msg}</div>}
                    <button type="submit" className="btn btn-primary">Devam Et</button>
                </form>
            )}

            {loading && (
                <div className="my-5">
                    <div className="spinner-border text-primary" role="status">
                        <span className="visually-hidden">Yükleniyor...</span>
                    </div>
                    <p className="mt-2 text-muted">Ödeme sayfası hazırlanıyor...</p>
                </div>
            )}

            {!loading && token && (
                <iframe
                    src={token}
                    id="paytriframe"
                    frameBorder="0"
                    style={{ width: "100%", height: "1000px" }}
                    title="Ödeme"
                ></iframe>
            )}
        </div>
    );
};

export default Odemetest;
